import { mapGiftCardTemplates } from "@/api/mapping/optional";

export default function ($api) {
    return {
        /**
         * Получение списка шаблонов подарочных карт
         * @returns {*}
         */
        getTemplates() {
            return $api.get("api/gift-card/templates/").then(mapGiftCardTemplates);
        },
        /**
         * Верификация и получение данных о заказе
         * @param verifyCode
         * @param coupon
         * @returns {*}
         */
        verify({ verifyCode, coupon }) {
            return $api.get("api/gift-card/verify/", { verifyCode, coupon });
        },
        /**
         * Покупка подарочной карты
         * @param form
         * @returns {*}
         */
        buy(form) {
            return $api.post("api/gift-card/buy/", form);
        },
    };
}
